module.exports = AreaData;